import {Box} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';
import {pageBodyPaddingBottom, pageBodyPaddingInline} from './constants';

export const Container = styled(Box, {
	paddingLeft: pageBodyPaddingInline,
	paddingRight: pageBodyPaddingInline,
	paddingBottom: pageBodyPaddingBottom,
});
